import type { FC, HTMLAttributes, PropsWithChildren } from "react";

import { I18n } from "@ui/components/I18n";
import classNames from "classnames";

import type { FlavorsSelection } from "@jti/fe-common";

import type { MultipleFlavorsSelectorItem } from "../../MultipleFlavorsSelector.types";
import { SelectionResultOverviewItem } from "../SelectionResultOverviewItem";

import styles from "./MultipleFlavorsSelectorResult.module.scss";

export type MultipleFlavorsSelectorResultProps = {
  items: MultipleFlavorsSelectorItem[];
  userSelection: FlavorsSelection;
  className?: string;
} & HTMLAttributes<HTMLDivElement>;

export const MultipleFlavorsSelectorResult: FC<PropsWithChildren<MultipleFlavorsSelectorResultProps>> = ({
  items,
  userSelection,
  className,
  ...restProps
}) => (
  <section
    className={classNames([styles.container, className])}
    data-testid="multiple-flavors-selector-result"
    aria-live="polite"
    {...restProps}
  >
    <h4 className={styles.headline}>
      <I18n t="productdetails.sticks.selectionLabel" />
    </h4>

    <div className={styles.selectedItemsOverview}>
      {Object.entries(userSelection).map(([selectedOptionId, quantity]) => {
        const selectedOption = items.find((option) => option.id.toString() === selectedOptionId);

        if (!selectedOption) return null;

        return (
          <SelectionResultOverviewItem
            key={selectedOptionId}
            label={selectedOption.name ?? ""}
            description={selectedOption.description ?? undefined}
            imageUrl={selectedOption.image.url ?? undefined}
            quantity={quantity}
          />
        );
      })}
    </div>
  </section>
);
